<template>
  <div class="card" @click.prevent="emitEvent">
    <div class="card-body" :style="getColor">
      <h1>{{ question }}</h1>
      <a href="#">{{ link }}</a>
    </div>

    <ModalAnswer :show="showAnswer" :question="question" :image="image" :answer="answer" :action="action" :colour="colour" @close="emitClose"></ModalAnswer>

  </div>
</template>

<script>
import apiStringMappings from '@/mixins/apiStringMapping'
import ModalAnswer from '@/components/models/ModalAnswer'

export default {
  name: 'QuestionCard',
  props: ['question', 'answer', 'link', 'action', 'image', 'colour'],
  mixins: [apiStringMappings],
  data () {
    return {
      showAnswer: false
    }
  },
  components: { ModalAnswer },
  computed: {
    getColor () {
      return 'background-color: ' + this.colour
    }
  },
  methods: {
    emitClose () {
      this.showAnswer = false
      this.$emit('close')
    },
    emitEvent () {
      this.showAnswer = true
    }
  }
}
</script>

<style scoped lang="scss">

  .card-body{
    cursor:pointer;
    opacity: 0.9;

    &:hover{
      opacity: 1;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/elements/QuestionCard.vue